/* eslint-disable prettier/prettier */
/* eslint-disable import/order */
import { Box, Button, Checkbox, FormControlLabel, FormGroup, Grid, MenuItem, Select, Switch } from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { IConnectivityExtraInfo, IConnectivityOption } from "../../interfaces/IConnectivityOption";
import { FormInputText } from "../form/FormInputText";
import ModelImage from "./modelImage";

interface Props {
  child: any; 
  childIndex: number; 
  connectivityOptions: IConnectivityOption[];
  copyStates: any; 
  editVehicle: boolean; 
  errors: any;
  handleConnectivityChange: (
    index: number,   
    value: string
  ) => void;
  handlecConnectivityExtraInfosChange: (
    index: number, 
    value?: IConnectivityExtraInfo
  ) => void;
  modelStates: any; setModelStates: (states: any) => void;
  showErrorMessage: () => void; vehicleData: any;
  yearFilter: { isEnabled: boolean; };
  updateCopyStates: (states: any) => void; 
  updateDeleteStates: (states: any) => void;
}

const VersionVehicle = ({
  child, 
  childIndex, 
  connectivityOptions, 
  copyStates, 
  editVehicle, 
  errors,
  handleConnectivityChange, 
  handlecConnectivityExtraInfosChange, 
  modelStates,
  showErrorMessage, 
  updateCopyStates, 
  updateDeleteStates, 
  vehicleData, 
  yearFilter,
}: Props) => {
  const NUMERIC_REGEX = /^[0-9-\s]+$/;

  const { register, control, setValue, watch } = useFormContext();
  const { t } = useTranslation();
  const [extraInfos, setExtraInfos] = useState<IConnectivityExtraInfo[]>([]);

  const currentConnectivity = watch(`versions.${childIndex}.connectivity`);
  const shouldShowOtto = currentConnectivity === "Patagônia" || currentConnectivity === "Carnet";

  function updateConnectivityExtraInfos(selectedConnectivity: string) {
    console.log("Selected connectivity:", selectedConnectivity);
    console.log("Connectivity options:", connectivityOptions);
    const selectedOption: any = connectivityOptions.find(
      (opt: any) => opt.connectivity === selectedConnectivity,
    );
    console.log("Selected option:", selectedOption);
    const infos = selectedOption?.connectivitiesInfos || [];

    console.log("Updating connectivity extra infos:", infos);
    setExtraInfos(infos);
  }

  useEffect(() => {
    if (!connectivityOptions?.length) return;
    const selectedConnectivity =
      vehicleData?.versions[childIndex]?.connectivity;

    if (selectedConnectivity) {
      updateConnectivityExtraInfos(selectedConnectivity);
    }
  }, [connectivityOptions]);


  return (
    <Box 
      sx={{ 
        borderTop: "1px solid #eee", pt: 2, mb: 4 
      }} 
      className={
        yearFilter.isEnabled && editVehicle 
          ? `year${vehicleData?.versions?.[childIndex]?.year}` 
          : ""
      }
    >
    <Grid 
      container 
      spacing={2} 
      columns={{ xs: 4, sm: 8, md: 12 }}>

        <Grid 
          sx={{ padding: "16px 0px 0px 16px" }}
          hidden={!copyStates.isEnabled}
        >
            <FormGroup>
              <FormControlLabel
                label={t("models.copy")}
                control={
                  <Checkbox
                    onChange={(event) => {
                      if (event.target.checked) {
                        child.version.map((aux: any) => {
                          updateCopyStates({
                            selectedVersions: [
                              ...copyStates.selectedVersions,
                              aux.id,
                            ],
                          });
                          return copyStates.selectedVersions;
                        });
                      } else {
                        let newArray: number[] = [];
                        child.version.map((aux: any) => {
                          newArray = copyStates.selectedVersions.filter(
                            (version: number) => version !== aux.id,
                          );
                          return child;
                        });
                        updateCopyStates({ selectedVersions: newArray });
                      }
                    }}
                  />
                }
              />
          </FormGroup>
        </Grid>

        <Grid size={4}>
          <FormInputText
            label={t("models.version")}
            type="text"
            {...register(`versions[${childIndex}].name`)}
            error={errors?.versions?.[childIndex]?.name}
          />
        </Grid>

        <Grid size={4}>
          <FormInputText
            label={t("models.modelCode")}
            type="text"
            {...register(`versions[${childIndex}].modelCode`)}
            error={errors?.versions?.[childIndex]?.modelCode}
          />
        </Grid>
        <Grid size={4}>
          <FormInputText
            label={t("models.year")}
            type="text"
            inputProps={{
              maxLength: 4,
              minLength: 4,
            }}
            onKeyDown={(event: any) => {
              if (
                event.key === "Backspace" ||
                event.key === "Tab" ||
                event.key === "ArrowRight" ||
                event.key === "ArrowLeft" ||
                event.key === "Delete"
              ) {
                return true;
              }
              if (!NUMERIC_REGEX.test(event.key)) {
                event.preventDefault();
              }
            }}
            {...register(`versions[${childIndex}].year`)}
            error={errors?.["versions"]?.[childIndex]?.["year"]}
            disabled={editVehicle && childIndex >= modelStates.newVersionCount}
          />
        </Grid>

        
        <Grid size={3}>
          <FormGroup sx={{ marginBottom: "1rem" }}>
            <FormControlLabel
              control={
                <Switch
                  id="isCognitive"
                  {...register(`versions[${childIndex}].isCognitive`)}
                  defaultChecked={
                    !modelStates.isNewModel
                      ? vehicleData.versions?.[childIndex]?.isCognitive
                        ? true
                        : false
                      : true
                  }
                />
              }
              label={t("models.isCognitive")}
            />
          </FormGroup>
        </Grid>
            
        <Grid size={3}>
          <FormGroup sx={{ marginBottom: "1rem" }}>
            <FormControlLabel
              label={t("models.isElectric")}
              control={
                <Switch {...register(`versions[${childIndex}].isElectric`)} 
                  defaultChecked={!!vehicleData?.versions?.[childIndex]?.isElectric} />
              } 
            />
          </FormGroup>
        </Grid>

        {shouldShowOtto && (
          <Grid size={2}>
            <FormGroup sx={{ marginBottom: "1rem" }}>
              <FormControlLabel
                label="Otto"
                control={
                  <Switch 
                    {...register(`versions[${childIndex}].hasOtto`)} 
                    checked={watch(`versions[${childIndex}].hasOtto`) || false}
                    onChange={(e) => {
                      setValue(`versions[${childIndex}].hasOtto`, e.target.checked, { shouldDirty: true });
                    }}
                  />
                } 
              />
            </FormGroup>
          </Grid>
        )}

        <Grid size={3}>
          <FormGroup sx={{ marginBottom: "1rem" }}>
            <FormControlLabel
              control={
                <Switch
                  id="hasSmartManual"
                  {...register(`versions[${childIndex}].hasSmartManual`)}
                  checked={watch(`versions[${childIndex}].hasSmartManual`) || false}
                  onChange={(e) => {
                      setValue(`versions[${childIndex}].hasSmartManual`, e.target.checked, { shouldDirty: true });
                  }}
                />
              }
              label={t("models.smartManual")}
            />
          </FormGroup>
        </Grid>

        <Grid size={6} sx={{ mb: 2 }}>
          <Controller 
            name={`versions.${childIndex}.connectivity`} 
            control={control} 
            render={({ field }) => (
              <Select
                {...field}
                style={{ marginRight: "16px" }}
                displayEmpty
                sx={{ height: 35, width: "184px" }}
                error={!!errors?.versions?.[childIndex]?.connectivity}
                value={field.value || ""}
                onChange={(event) => {
                  const newConnectivity = event.target.value;
                  field.onChange(newConnectivity);
                  handleConnectivityChange(childIndex, newConnectivity);
                  updateConnectivityExtraInfos(newConnectivity);

                  if (newConnectivity !== "Patagônia" && newConnectivity !== "Carnet") {
                    setValue(`versions[${childIndex}].hasOtto`, false, { shouldDirty: true });
                  }

                  setValue(`versions[${childIndex}].isCarNetEnabled`, newConnectivity === "Carnet", { shouldDirty: true });
                  setValue(`versions[${childIndex}].isPatagoniaEnabled`, newConnectivity === "Patagônia", { shouldDirty: true });
                  
                  if (newConnectivity === "VwPlay") {
                    setValue(`versions[${childIndex}].vwPlay`, true, { shouldDirty: true });
                  }
                }}
              >
                <MenuItem disabled value="">
                  <em>{t("models.conectivityType")}</em>
                </MenuItem>

                {connectivityOptions.map((option: any) => (
                  <MenuItem 
                    key={option.connectivity}   
                    value={option.connectivity}
                  >
                    {option.connectivity}
                  </MenuItem>
                ))}
              </Select>
          )} />

          {extraInfos.length > 0 && (
            <Controller 
              name={`versions.${childIndex}.connectivityExtraInfo`} 
              control={control} 
              render={({ field }) => (
                
              <Select
                {...field}
                displayEmpty
                sx={{ 
                  height: 35, 
                  width: "184px" 
                }}
                error={!!errors?.versions?.[childIndex]?.connectivityExtraInfo}
                value={field.value?.id || ""}
                onChange={(event) => {
                  const selectedId = event.target.value;
                  const selectedOption = extraInfos.find(opt => opt.id === selectedId);

                  if (selectedOption) {
                    field.onChange({ id: selectedOption.id, info: selectedOption.info });
                    handlecConnectivityExtraInfosChange(childIndex, selectedOption);
                  }
                }}
              >
                <MenuItem disabled value="">
                  <em>{t("models.connectivityExtraInfos")}</em>
                </MenuItem>
                {extraInfos.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.info}
                  </MenuItem>
                ))}
              </Select>
            )} />
          )}
        </Grid>
      </Grid>

      <ModelImage 
        childIndex={childIndex} 
        errors={errors} 
        data={vehicleData} 
      />

      <Box
        sx={{
          display: "flex",
          placeItems: "center",
          gap: "1rem",
        }}
      >
        <Button
          variant="contained"
          color="error"
          type="button"
          sx={{ marginY: 2 }}
          onClick={() => {
            if (modelStates.childrenLength === 1) {
              return showErrorMessage();
            }

            updateDeleteStates({
              targetVersionIndex: childIndex,
              showConfirmDialog: true,
            });
          }}
        >
          {t("models.deleteVersion")}
        </Button>
        <Box
          sx={{
            color: "var(--red-100)",
            display: "none",
          }}
          id="requiredVersion"
        >
          <span>{t("models.requiredVersion")}</span>
        </Box>
      </Box>
    </Box>
  );
};

export default VersionVehicle;